<template>
    <section class="title2">
        <ogt-video ref="video" src="/static/video/medewerker.mp4" poster="/static/video/medewerker-poster.jpg"></ogt-video>
        <p>Hier werkten we aan in 2020 - onze 5 strategische doelen</p>

        <div class="list">
            <div class="point" @click="$router.push('/Onderwijskwaliteit')">
                <div class="number">1</div>
                <label>Aantoonbare <br/>onderwijs&shy;kwaliteit</label>
            </div>
            <div class="point" @click="$router.push('/Carriere')">
                <div class="number">2</div>
                <label>Opleiden voor <br/>een carri&egrave;re</label>
            </div>
            <div class="point" @click="$router.push('/Regio')">
                <div class="number">3</div>
                <label>Positie in <br class="hide-for-small" />de regio</label>
            </div>
            <div class="point active">
                <div class="number">4</div>
                <label>Medewerker<br />3.0</label>
            </div>
            <div class="point" @click="$router.push('/Duurzaam')">
                <div class="number">5</div>
                <label>Duurzaam <br/>verbeteren</label>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_title.scss
</style>

<script>
    import Tekst from '@/app/pages/medewerker/Tekst';
    import Tekst2 from '@/app/pages/medewerker/Tekst2';
    import Interview from '@/app/pages/medewerker/Interview';
    import VideoEmbed from '@/app/pages/medewerker/VideoEmbed';
    import OgtVideo from '@/app/components/OgtVideo';
    // import InfoScholing from '@/app/pages/medewerker/InfoScholing';
    import InfoModules from '@/app/pages/medewerker/InfoModules';
    import InfoModuleRanking from '@/app/pages/medewerker/InfoModuleRanking';
    // import InfoModuleTijdstip from '@/app/pages/medewerker/InfoModuleTijdstip';
    // import InfoModuleUitleg from '@/app/pages/medewerker/InfoModuleUitleg';

    import InterviewCaro from '@/app/pages/sub/InterviewCaro';

    export default {
        name: 'Medewerker',
        meta: {
            title: '4.4 Medewerker 3.0',
            color: '#36B1CA',
            sub: true,
            slides: [ Tekst, Interview, VideoEmbed, Tekst2, InfoModules, InfoModuleRanking ]
        },

        components: {
            'ogt-video': OgtVideo
        },

        props: {
            meta: {
                default: () => {},
                type: Object
            }
        },

        mounted()
        {
        },

        methods: {
            focus()
            {
                this.$refs.video.play();
            },
            blur()
            {
                this.$refs.video.pause();
            },
            sub( name )
            {
                switch( name )
                {
                    case 'Caro':
                        this.$emit( 'openOverlay', InterviewCaro, this.meta.index + 2 );
                        break;
                }
            }
        }
    };
</script>
